import { SystemMessage } from "@app/constants";
import * as Yup from "yup";

export const createReferredCodeValidationSchema = Yup.object().shape({
  referredCode: Yup.string().required(SystemMessage.INPUT_REQUIRED),
});
